import SportsEsportsOutlinedIcon from '@mui/icons-material/SportsEsportsOutlined';
import RedeemOutlinedIcon from '@mui/icons-material/RedeemOutlined';
import InsightsOutlinedIcon from '@mui/icons-material/InsightsOutlined';
import BoltOutlinedIcon from '@mui/icons-material/BoltOutlined';
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
// Marketing bullets for the auth pages' brand panel. Two sets: one for visitors who already have an
// account (sign-in and the password flows), one for the sign-up page.
export const RETURNING_USER_HIGHLIGHTS = [
    {
        icon: <SportsEsportsOutlinedIcon sx={{ fontSize: 18 }}/>,
        title: 'Your drops, in one place',
        description: 'Pick up the dares and campaigns you already joined.',
    },
    {
        icon: <RedeemOutlinedIcon sx={{ fontSize: 18 }}/>,
        title: 'Claim what you earned',
        description: 'Keys, points and rewards are waiting in your account.',
    },
    {
        icon: <InsightsOutlinedIcon sx={{ fontSize: 18 }}/>,
        title: 'Track how you perform',
        description: 'Publishers and creators get the same live numbers.',
    },
];
export const NEW_USER_HIGHLIGHTS = [
    {
        icon: <BoltOutlinedIcon sx={{ fontSize: 18 }}/>,
        title: 'Free to join',
        description: 'No cost, no commitment. Play the dares you like.',
    },
    {
        icon: <EmojiEventsOutlinedIcon sx={{ fontSize: 18 }}/>,
        title: 'Get rewarded',
        description: 'Earn game keys, points and prizes from publishers.',
    },
    {
        icon: <GroupsOutlinedIcon sx={{ fontSize: 18 }}/>,
        title: 'Built for both sides',
        description: 'Creators grow their audience, publishers reach it.',
    },
];
